<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title></title>
<link href="style.css" rel="stylesheet" type="text/css"/>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<p class="pc0"><i>A Selection of Recent Titles by Judith Cutler</i></p>
<p class="pc3"><i>The Lina Townend Series </i></p>
<p class="pc">DRAWING THE LINE</p>
<p class="pc">SILVER GUILT *</p>
<p class="pc">RING OF GUILT *</p>
<p class="pc">GUILTY PLEASURES *</p>
<p class="pc">GUILT TRIP *</p>
<p class="pc3"><i>The Frances Harman Series</i></p>
<p class="pc">LIFE SENTENCE</p>
<p class="pc">COLD PURSUIT</p>
<p class="pc">STILL WATERS</p>
<p class="pc3"><i>The Josie Welford Series</i></p>
<p class="pc">THE FOOD DETECTIVE</p>
<p class="pc">THE CHINESE TAKEOUT</p>
<p class="pc4"><i>* available from Severn House</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsoby.vue?4530a682